import axios from 'axios';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import swal from 'sweetalert'
import { checkStringContains, baseURL } from './domainValidator'


const RequestDemo = forwardRef(({ children, ...props }, ref) => {

    const [emailDomainData, setEmailDomainData] = useState([])

    const today = new Date().toISOString().split('T')[0]; 


    const twoDaysFromNow = new Date();
    twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);
    let staticDate = new Date();
    const yearMin = staticDate.getFullYear();
    const monthMin = String(staticDate.getMonth() + 1).padStart(2, "0");
    const dayMin = String(staticDate.getDate()).padStart(2, "0");
    const yearMax = twoDaysFromNow.getFullYear();
    const monthMax = String(twoDaysFromNow.getMonth() + 1).padStart(30, "0");
    const dayMax = String(twoDaysFromNow.getDate()).padStart(365, "0");

    const [formData, setFormData] = useState({
        name: "",
        workMail: "",
        time: "",
        application: window.location.pathname === '/vAutomate' ? 'vAutomate' : 
                     window.location.pathname === '/bullseye' ? 'BullsEye' : 
                     window.location.pathname === '/observer' ? 'The Observer' :
                     window.location.pathname === '/compliance-engine' ? 'Network Compliance Platform' :
                     ''
    });


    const [modal, setModal] = useState(false)

    const [nameError, setNameError] = useState("")
    const [workmailError, setWorkmailError] = useState("")
    const [timeError, setTimeError] = useState("")
    const [ddError, setDdError] = useState("");
    const [inputType, setInputType] = useState("text");
    const [scheduled, setScheduled] = useState("");
        const [disableSubmitNow, setDisableSubmitNow] = useState(false)
    



    const handleFocus = () => {

        setInputType("datetime-local");

    };

    const handleBlur = () => {

        setInputType("text");

    };

   const handleManually=(event)=>{
    event.preventDefault();
   }


    const handleChangeDate = (e) => {

        let onlyDateValueAfterChange = e.target.value.split("T")[0];
        let staticDate = new Date();
        const yearMin = staticDate.getFullYear();
        const monthMin = String(staticDate.getMonth() + 1).padStart(2, "0");
        const dayMin = String(staticDate.getDate()).padStart(2, "0");
        const hours = String(staticDate.getHours()).padStart(2, "0"); // Ensure two digits
        const minutes = String(staticDate.getMinutes()).padStart(2, "0"); // Ensure two digits
        let currentDate = `${yearMin}-${monthMin}-${dayMin}`;
        const minTime =

            onlyDateValueAfterChange == currentDate ? `${hours}:${minutes}` : "00:01";

        const maxTime = "23:59";




        let selectedValue = e.target.value;
        setFormData(prev => ({ ...prev, time: selectedValue}));


        // console.log("selectedValue", selectedValue)




        const [date, time] = selectedValue.split("T");




        if (time) {

            if (time < minTime) {
                selectedValue = `${date}T${minTime}`;
                alert("Can't select past times");

            } else if (time > maxTime) {

                // console.log("line 365");
                selectedValue = `${date}T${maxTime}`;
            }
        }


        // setFormData(prev => ({ ...prev, time: selectedValue }));

    };

    const getDomainNameData=()=>{
        const headers = {headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Frame-Options': 'DENY'}};
        fetch(`${baseURL}/getEmailDomains`, headers)
            .then(res => res.json())
            .then(json =>{
                setEmailDomainData(json.data.email_domains)
            }).catch((error) => {
              console.error("Error fetching data:", error);
          });
      }

    const validation = () => {
        const nameFieldRegex = /^[^\s].+[a-zA-Z]+[a-zA-Z]+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let validated = true;
        if (formData.name.trim() == "") {
            const nameError = "Please Enter your Full Name";
            setNameError(nameError)
            validated = false
        } else {
            if (!nameFieldRegex.test(formData.name)) {
                const nameError = "Please Enter your Valid Full Name";
                setNameError(nameError)
                validated = false
            } else {
                const nameError = "";
                setNameError(nameError)
            }
        }


        if (emailRegex.test(formData.workMail) == false) {
            const wMError = "Please Enter your Official Email ID";
            setWorkmailError(wMError)
            validated = false
        } else {
            let temptValidator= checkStringContains(emailDomainData, formData.workMail)
            if (temptValidator === false) {
                const wMError = "Please Enter valid Official Email ID";
                setWorkmailError(wMError)
                validated = false;
            } else {
                const wMError = "";
                setWorkmailError(wMError)
            }
        }


        if (formData.time == "") {
            const tError = "Please Select your preferred date for the Demo";
            setTimeError(tError)
            validated = false
        } else {

            console.log('formData', formData.time)
            const tError = "";
            setTimeError(tError)
        }


        if (formData.application == "") {
            const aError = "Choose the tool you want a demo for";
            setDdError(aError)
            validated = false
        } else {
            const aError = "";
            setDdError(aError)
        }

        return validated
    }



    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === 'name') {
            setFormData((prev) => ({ ...prev, name: value }))
        }

        if (name === 'workMail') {
            setFormData((prev) => ({ ...prev, workMail: value }))
        }
        if (name === 'time') {
            setFormData((prev) => ({ ...prev, time: value }))
        }
        if (name === 'application') {
            setFormData((prev) => ({ ...prev, application: value }))
        }

    }
    const openModal = () => {
        setModal(!modal)

        setNameError("")
        setWorkmailError("")
        setTimeError("")
        setDdError("");
    }

    useEffect(()=>{
        getDomainNameData()
    }, [])


    useImperativeHandle(ref, () => ({
        openModal
    }));


    const handleSubmit = () => {
      
        let valid = validation();

        if (valid) {
            setDisableSubmitNow(true)
            axios.post(`${baseURL}/requestDemo`, {
                ...formData
            }).then((response) => {
                swal('Success', `${response?.data?.message}`, 'success')
                setModal(false);
                setDisableSubmitNow(false)
            }).catch((error) => {

                swal('Error', `something went wrong`, 'error')
                setModal(false);
                setDisableSubmitNow(false)

            }).finally(()=>{
                setFormData({
                    name: "",
                    workMail: "",
                    time: "",
                    application: ""
                });
        
                setNameError("")
                setWorkmailError("")
                setTimeError("")
                setDdError("");
            })
        }

    }


    return (
        <>
            <Modal isOpen={modal} >
                <ModalHeader toggle={openModal}>Request for Demo</ModalHeader>
                <ModalBody>
                    <div className='conatct-form'>
                        <label>Name
                            <span className='text-danger'>*</span>

                        </label>

                        {nameError ? <small className='text-danger'>{nameError}</small> : null}
                        <input
                            //  value={name} onChange={handleChange} 
                            className='form-control mb-2'
                            name='name'
                            onChange={(e) => handleChange(e)}
                            value={formData.name}
                            maxLength={51}

                        />


                        <label>Official Email ID<span className='text-danger'>*</span></label>
                        {workmailError ? <small className='text-danger'>{workmailError}</small> : null}
                        <input
                            // value={props.cName} 
                            className='form-control mb-2'
                            name='workMail'
                            onChange={(e) => handleChange(e)}
                            value={formData.workMail}
                            maxLength={101}
                        />



                        <label>Date<span className='text-danger'>*</span></label>
                        {timeError ? <small className='text-danger'>{timeError}</small> : null}

                        <input
                         className='form-control mb-2'
                            type={'date'}
                            onKeyDown={handleManually}
                            // step="900"
                            // placeholder="Schedule Execution"
                            placeholder="DD-MM-YYYY"
                            title="Schedule Date"
                            // onFocus={handleFocus}
                            // onBlur={handleBlur}
                            onChange={handleChangeDate}
                            value={formData.time}
                            min={today}
                            // min={`${yearMin}-${monthMin}-${dayMin}T00:00`}
                            // max={`${yearMax}-${monthMax}-${dayMax}T23:59`}
                        />

                        {/* <input value={formData.time} type='datetime-local' onChange={handleChange} className='form-control mb-2' name='time' /> */}
                        {/* <input
                            //  value={workMail} onChange={handleChange} 
                            className='form-control mb-2'
                             name='time'
                            onChange={(e) => handleChange(e)}
                            value={formData.time}
                        /> */}


                        <label>Tools/Platforms<span className='text-danger'>*</span></label>
                        {ddError ? <small className='text-danger'>{ddError}</small> : null}

                        <select
                            className='form-control mb-2'
                            name='application'
                            onChange={(e) => handleChange(e)
                            }
                            value={formData.application}
                        >
                            <option value="" disabled>Select Tools/Platforms</option>
                            <option value="BullsEye">BullsEye</option>
                            <option value="Network Compliance Platform">Network Compliance Platform</option>
                            <option value="The Observer">The Observer</option>
                            <option value="vAutomate">vAutomate</option>
                        </select>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className='btn-custom d-block w-100 border-0' onClick={() => handleSubmit()} disabled={disableSubmitNow}>Submit</button>
                </ModalFooter>
            </Modal>


        </>
    )
}
)

export default RequestDemo
